// Derived From http://www.javascriptkit.com/dhtmltutors/ajaxgetpost4.shtml
// NOTE there is a new snap_request that uses promises. Transition to that and hopefully we can eliminate this file
function AjaxRequest() {
  const activeXModes = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP']; // activeX versions to check for in IE

  // Test for support for ActiveXObject in IE first (as XMLHttpRequest in IE7 is broken)
  if (window.ActiveXObject) {
    for (let i = 0; i < activeXModes.length; i += 1) {
      try {
        return new ActiveXObject(activeXModes[i]);
      } catch (e) {
        // Suppress error
      }
    }
  } else if (window.XMLHttpRequest) { // if Mozilla, Safari etc
    return new XMLHttpRequest();
  }

  return false;
}

export function ajax(url, kind, body, success, failure, headers = {}) {
  const request = new AjaxRequest();
  request.onreadystatechange = () => {
    if (request.readyState === 4) {
      if (request.status >= 200 && request.status < 300) {
        success(request);
      } else {
        failure(request);
      }
    }
  };

  request.open(kind, url, true);
  Object.keys(headers).forEach(k => {
    request.setRequestHeader(k, headers[k]);
  });

  request.send(body);
  return request;
}

export function get(url, success, failure, headers = {}) {
  return ajax(url, 'GET', null, success, failure, headers);
}

export function post(url, body, success, failure, headers = {}) {
  return ajax(url, 'POST', body, success, failure, headers);
}

export function destroy(url, success, failure, headers = {}) {
  return ajax(url, 'DELETE', null, success, failure, headers);
}

export function getJSON(url, callback, headers = {}) {
  return get(url,
    (request) => {
      // retrieve result as an JavaScript object
      const json = JSON.parse(request.responseText);
      callback(json);
    },
    (request) => {
      callback({ error: `Request failed ${request}` });
    },
    headers,
  );
}
